import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'
import RequireAuth from 'components/smart/RequiredAuth'
import SessionProvider from 'components/smart/SessionProvider'
import RequiredAdmin from 'components/smart/RequiredAdmin'
import RequiredOnboarding from 'components/smart/RequiredOnboarding'
import ApprovalCenterRoutes from 'pages/approval-center/routes'
import AuthProvider from 'contexts/AuthContext'
import SuperAdminRoutes from 'module/sign-up/superAdminRoutes'

import Home from 'pages/home/view/Home'
import Login from 'pages/login/view/Login'
import EAForm from 'pages/ea-form-generator/view'
import JobBoard from 'pages/job-board/view/JobBoard'
import InstallApp from 'pages/install-app/view/InstallApp'

import OnboardingResetPassword from 'pages/onboarding-reset-password/view/OnboardingResetPassword'
import OnboardingPersonalDetails from 'pages/onboarding-personal-details/view/OnboardingPersonalDetails'
import OnboardingJobInformation from 'pages/onboarding-job-information/view/OnboardingJobInformation'
import OnboardingContactDetails from 'pages/onboarding-contact-details/view/OnboardingContactDetails'
import OnboardingLiftOff from 'pages/onboarding-lift-off/view/OnboardingLiftOff'

import Dashboard from 'pages/dashboard/view/Dashboard'
import Notifications from 'pages/notifications/view/Notifications'
import Announcements from 'pages/announcements/view/Announcements'
import PageNotFound404 from 'pages/404/view/PageNotFound404'

import TaskRoutes from 'module/task-management/routes'

import ClaimRoutes from 'module/claim/routes'
import LeaveRoutes from 'module/leave/routes'
import PayrollRoutes from 'module/payroll/routes'
import { PerformanceRoutes, AppraisalRoutes } from 'module/performance/routes'

import ManageEmployeeFile from 'module/staff-management/pages/ManageEmployeeFile'

import SignUpRoutes from 'module/sign-up/routes'
import PaySlipDownload from 'pages/payslip/PaySlipDownload'
import PayrollDownloadAnnualReport from 'module/payroll/pages/payroll-history/view/PayrollDownloadAnnualReport'

import Colors from 'guidelines/colors/view/Colors'
import Grid2x2 from 'guidelines/components/view/Grid2x2'
import Grid3x3 from 'guidelines/components/view/Grid3x3'
import RecruitmentRoutes from 'module/recruitment/routes'
// import { StaffRetentionRoutes } from 'module/staff-retention/routes'

// Temporary
import Terms from 'pages/home/view/Terms'
import UpskillOverview from 'module/upskill/view/UpskillOverview'
import OrganizationalAdminRoutes from 'pages/organizational-admin/routes'
import SpecificJobBoard from 'pages/job-board/view/SpecificJobBoard'
import { useEffect } from 'react'
import TimeAttendance from 'module/time-attendance/view/TimeAttendance'
import AttendanceTrackingAll from 'module/time-attendance/view/AttendanceTrackingAll'
import AttendanceTrackingIndividual from 'module/time-attendance/view/AttendanceTrackingIndividual'
import Playground from 'guidelines/components/view/Playground'
// import Chat from 'pages/chat_off/view/Chat'
import WebSocketTest from 'components/WebSocketTest'

const MainRoutes = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return (
    <>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/install-app" element={<InstallApp />} />
        <Route path="/signup/*" element={<SignUpRoutes />} />
        {/* <Route path="/ea-form" element={<EAForm />} /> */}
        <Route path="/job-board/:companyName/:uuid" element={<JobBoard />} />
        <Route path="/job-board/:companyName/:uuid/:id" element={<SpecificJobBoard />} />

        {/* Temporary Route */}
        <Route path="/terms-conditions" element={<Terms />} />

        {/* This route is specific for documents direct download from email */}
        <Route path="download" element={<Outlet />}>
          <Route path="payslip/:id" element={<PaySlipDownload />} />
        </Route>

        {/* Private Route */}
        <Route element={<AuthProvider />}>
          <Route element={<RequireAuth />}>
            <Route element={<SessionProvider />}>
              <Route path="/super-admin-onboarding/*" element={<SuperAdminRoutes />} />
              <Route path="/onboarding-reset-password" element={<OnboardingResetPassword />} />
              <Route path="/onboarding-personal-details" element={<OnboardingPersonalDetails />} />
              <Route path="/onboarding-job-information" element={<OnboardingJobInformation />} />
              <Route path="/onboarding-contact-details" element={<OnboardingContactDetails />} />
              <Route path="/onboarding-lift-off" element={<OnboardingLiftOff />} />

              <Route element={<RequiredOnboarding />}>
              <Route path="app" element={<Outlet />}>
                <Route index element={<Navigate to="homepage" />} />
                <Route path="homepage" element={<Dashboard />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="announcements" element={<Announcements />} />
                {/* <Route path="chat" element={<Chat />} /> */}
                {/* <Route path="websocket-test" element={<WebSocketTest />} /> */}

                <Route path="profile/:id" element={<ManageEmployeeFile />} />

                {/* To refactor this under download route */}
                <Route path="profile/annual-report" element={<Outlet />}>
                  <Route path={':year/:form'} element={<PayrollDownloadAnnualReport />} />
                </Route>
                {/* ///////////// */}

                <Route path="tasks-dashboard/*" element={<TaskRoutes />} />

                <Route path="performance/*" element={<PerformanceRoutes />} />
                <Route path="claim/*" element={<ClaimRoutes />} />
                <Route path="leave/*" element={<LeaveRoutes />} />
                <Route path="upskill/*" element={<UpskillOverview />} />
                <Route path="attendance" element={<TimeAttendance />} />

                {/* Admin Only Route */}
                <Route element={<RequiredAdmin />}>
                  <Route path="approval-center/*" element={<ApprovalCenterRoutes />} />
                  <Route path="management-centre/*" element={<OrganizationalAdminRoutes />} />
                  <Route path="payroll/*" element={<PayrollRoutes />} />
                  <Route path="recruitment/*" element={<RecruitmentRoutes />} />
                  <Route path="appraisal-cycle/*" element={<AppraisalRoutes />} />
                  {/* maybe change for admin settings, add routes */}
                  <Route path="attendance-records" element={<AttendanceTrackingAll />} />
                  <Route path="attendance-records/individual" element={<Outlet />}>
                    <Route path={':id'} element={<AttendanceTrackingIndividual />} />
                  </Route>

                  {/* hide staff retention routes */}
                  {/* <Route path="staff-retention/*" element={<StaffRetentionRoutes />} /> */}
                </Route>
              </Route>
              </Route>
            </Route>
          </Route>
        </Route>
        {/* </Route> */}

        {/* FOR DEVELOPERS ONLY */}
        {process.env.NODE_ENV !== 'production' && (
          <>
            <Route path="/colors" element={<Colors />} />
            <Route path="/playground" element={<Playground />} />
            <Route path="/grid/2" element={<Grid2x2 />} />
            <Route path="/grid/3" element={<Grid3x3 />} />
          </>
        )}

        <Route path="*" element={<PageNotFound404 />} />
      </Routes>
    </>
  )
}

export default MainRoutes
